// jQuery, dayjs, and Dropzone are loaded from CDN in layouts
// This avoids bundling them twice and reduces app.js size significantly

require('popper.js');
require('./bootstrap');

// Load jQuery plugins AFTER jQuery is available (jQuery comes from CDN)
require('metismenu');
require('jquery-typeahead');
require('jquery-form');
// jquery.numeric removed from global bundle; only used by billingactivation.js + eventedit.js.
// Loaded per-page via <script src="{{ asset('js/jquery.numeric.js') }}"> in billing/event blades.
// toastr replaced by Toastify-js (loaded via CDN in the layouts; see notify() in global.js).

// dayjs is loaded from CDN (en locale is the default; no setup needed)

window.toTitleCase = function (str) {
    return str.replace(/(?:^|\s)\w/g, function (match) {
        return match.toUpperCase();
    });
};
